import { render, staticRenderFns } from "./villageAnalyze.vue?vue&type=template&id=219f31c7&scoped=true&"
import script from "./villageAnalyze.vue?vue&type=script&lang=js&"
export * from "./villageAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./villageAnalyze.vue?vue&type=style&index=0&id=219f31c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f31c7",
  null
  
)

export default component.exports